import { getLocalApi } from "./localApi";
import { UnitType} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllUnitTypes() : Promise<UnitType[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_unit_types, (dto:any) => ({
        name: dto.name,
        id: dto.id,
        allowedProductTypes: Array.isArray(dto?.allowedProductTypes) ? dto.allowedProductTypes : []
    }), 'Unable to fetch Unit Types')
}